import { __decorate } from "tslib";
import { registerDecorator, ValidatorConstraint } from "class-validator";
import { DependsOn } from "./DependsOn";
export function EqualsProperty(property, validationOptions) {
    return (object, propertyName) => {
        DependsOn(property, validationOptions)(object, propertyName);
        registerDecorator({
            target: object.constructor,
            propertyName,
            options: validationOptions,
            constraints: [property],
            validator: EqualsPropertyConstraint,
        });
    };
}
let EqualsPropertyConstraint = class EqualsPropertyConstraint {
    validate(value, args) {
        const [relatedPropertyName] = args.constraints;
        const relatedValue = args.object[relatedPropertyName];
        return value === relatedValue;
    }
    defaultMessage(args) {
        const [relatedPropertyName] = args.constraints;
        return `${relatedPropertyName} and ${args.property} don't match`;
    }
};
EqualsPropertyConstraint = __decorate([
    ValidatorConstraint({ name: "equalsProperty" })
], EqualsPropertyConstraint);
export { EqualsPropertyConstraint };
//# sourceMappingURL=EqualsProperty.js.map